import { render, staticRenderFns } from "./claimProcessDialog.vue?vue&type=template&id=be7d3c04&scoped=true"
import script from "./claimProcessDialog.vue?vue&type=script&lang=js"
export * from "./claimProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./claimProcessDialog.vue?vue&type=style&index=0&id=be7d3c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d3c04",
  null
  
)

export default component.exports